export default __webpack_public_path__ + "static/media/hero-slide1-bg.ee10d32e.webp";